<template>
  <div id="viaticRequestComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <b-tabs pills active-nav-item-class="primary" v-model="tabIndex">
        <!-- <b-tab @click="get('CREATED')" v-if="userLogged.validator == null"> -->
        <b-tab @click="get('CREATED')">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('viatics.status.created') }}</h5>
          </template>
        </b-tab>
        <b-tab @click="get('IN_REVIEW')">
          <template variant="primary" v-slot:title>
            <!-- <h5 class="my-0">
              {{
                isValidator()
                  ? $t('viatics.status.toValidate')
                  : $t('viatics.status.inValidation')
              }}
            </h5> -->
            <h5 class="my-0">
              {{ $t('viatics.status.inValidation') }}
            </h5>
          </template>
        </b-tab>
        <b-tab @click="get('APPROVED')">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">
              {{
                isValidator()
                  ? $t('viatics.status.approbed')
                  : $t('viatics.status.validated')
              }}
            </h5>
          </template>
        </b-tab>
        <b-tab @click="get('REJECTED')">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{ $t('viatics.status.rejected') }}</h5>
          </template>
        </b-tab>
      </b-tabs>
      <v-layout>
        <v-flex md-6>
          <v-text-field
            v-model="viaticSearch"
            :label="$t('general.search')"
            clearable
            append-outer-icon="search"
          >
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs3 class="text-right">
          <!-- BOTON ADD NEW -->
          <v-btn v-if="status === 'CREATED'" @click="dialogRequest = true" color="primary">
            <v-icon left>add</v-icon>
            {{ $t('viatics.new') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headersFiltered"
        :search="viaticSearch"
        :items="filterViatics"
        :loading="loadingItems"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 15, 25]"
        class="elevation-1"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'asc' : 'desc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :class="{ selectedRow: isApprovedAndExtensionReview(props.item) && status === 'IN_REVIEW' && isValidator() }">
            <td class="text-sm-center">{{ props.item.folio }}</td>
            <td class="text-sm-center" v-if="status === 'IN_REVIEW'">{{ props.item.user !== null ? props.item.user.name : '' }}</td>
            <td class="text-sm-center">{{ props.item.creation_date }}</td>
            <td class="text-sm-center">{{ props.item.start_date }} / {{ props.item.end_date }}</td>
            <td class="text-sm-center">{{ props.item.project.name }}</td>
            <td class="text-sm-center">{{ props.item.description }}</td>
            <td class="text-sm-center">{{ advanceCalculate(props.item, props.item.amount_advance) | formatCurrency }}</td>
            <td class="text-sm-center" style="width: 180px; padding: 0px">
              <v-tooltip bottom v-if="status === 'CREATED' || status === 'REJECTED'" class="ma-0 pa-1">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-0 pa-1"
                    small
                    outline
                    icon
                    color="info"
                    v-on="on"
                    @click="editItem(props.item)"
                    :disabled="actionsLoading === true"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.edit') }}</span>
              </v-tooltip>
              <!-- COPIAR GASTO -->
              <v-tooltip bottom v-if="status === 'IN_REVIEW'" class="ma-0 pa-1">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-0 pa-0"
                    small
                    outline
                    icon
                    v-if="status === 'IN_REVIEW'"
                    color="info"
                    v-on="on"
                    @click="getValidador(props.item)"
                  >
                  <v-icon small>history</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.history') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="status !== 'CREATED'" class="ma-0 pa-1">
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-0 pa-0" small outline icon color="info" v-on="on" @click="confirmCopyExpense(props.item)">
                    <v-icon small>content_copy</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('viatics.copyExpense') }}</span>
              </v-tooltip>
              <!-- COPIAR GASTO -->
              <v-tooltip bottom v-if="status !== 'CREATED'" class="ma-0 pa-1">
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-0 pa-0" small outline icon color="info" v-on="on" @click="editItem(props.item, true)">
                    <v-icon small>remove_red_eye</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('viatics.details') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="status === 'CREATED'" class="ma-0 pa-1">
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-0 pa-0" small outline icon color="info" @click="confirmSendToValidate(props.item)" v-on="on">
                    <v-icon small>mdi-send</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('viatics.send') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="status === 'CREATED' || status === 'REJECTED'" class="ma-0 pa-1">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        color="#F7665E"
                        @click="confirmDelete(props.item)"
                        outline
                        icon
                        v-on="on"
                        class="ma-0 pa-0"
                      >
                        <v-icon small>mdi-trash-can</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('viatics.deleteRequest') }}</span>
                  </v-tooltip>
              <!-- TODO: MODIFICACION HISTORIA 501-->

              <v-tooltip bottom v-if="status === 'APPROVED'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    :disabled="props.item.gst_expense !== null"
                    outline
                    icon
                    v-if="status === 'APPROVED'"
                    color="primary"
                    v-on="on"
                    @click="createExpense(props.item)"
                  >
                    <v-icon small>fas fa-file-invoice-dollar</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('expenses.create') }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="dialogViewFile" scrollable max-width="900px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.file') + ': ' + watchItem.id}}</h2>
          </v-toolbar>
          <v-card-text class="text-center">
            <iframe v-if="watchItem.files_type_id === 3 && dataURLFile" :src="dataURL" frameborder="0" width="100%" height="400px" />
            <zoom-on-hover v-if="dataURLFile && watchItem.files_type_id !== 3" :img-normal="dataURLFile"/>
            <v-btn color="primary" @click="downloadFile()" :loading="loadBtn" :disabled="loadBtn" v-if="(watchItem.files_type_id === 9 || watchItem.files_type_id === 12) && !loadFile">volver a descargar</v-btn>
            <v-progress-circular v-if="!dataURLFile && loadFile" color="primary" size="50" indeterminate />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" round flat @click="closeViewFile"> {{ $t('general.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- CONFIRMAR COPIA DE SOLICITUD -->
      <v-dialog persistent v-model="confirmCopyRequestDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('viatics.copyExpense') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('viatics.confirmCopyExpense') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="closeConfirmCopyRequestDialog">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn color="primary" round depressed  @click="copyExpense">
              {{ $t('general.copy') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="addExpenseDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.view') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.viewMessage') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="closeAddExpenseDialog">{{ $t('general.close') }}</v-btn>
            <v-btn color="primary" round depressed :loading="loading" :disabled="loading" @click="sendExpenseView">{{ $t('expenses.view') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- AGREGAR GASTO -->
      <v-dialog v-model="dialogRequest" max-width="1370px" scrollable persistent>
        <v-card>
          <v-toolbar class="primary--text" flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ formTitle }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <!--v-container class="mx-4"-->
              <v-form lazy-validation ref="form" v-model="validApproved" class="mx-2 px-2">
                <v-layout>
                  <v-flex md12>
                    <div v-if="status === 'REJECTED'" class="mt-0">
                      <h3 class="font-weight-black primary--text mb-0">
                        {{ $t('viatics.reasonRejected') }}
                      </h3>
                    </div>
                    <div v-if=" status === 'APPROVED' && editedItem.comment !== null " class="subtitle-1 mt-2">
                      {{ $t('viatics.validationMessage') }}:
                    </div>
                    <v-layout v-if=" (status === 'APPROVED' || status === 'REJECTED') && editedItem.comment !== null">
                      <v-flex xs12>
                        <table style="width: 100%" class="styled-table">
                            <thead>
                                <tr>
                                    <th style="font-size: 15px; text-align: center;">{{ $t('validator.name') }}</th>
                                    <th style="font-size: 15px; text-align: center;">{{ $t('validator.date') }}</th>
                                    <th style="font-size: 15px; text-align: center;">{{ $t('general.comment') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="active-row">
                                  <td>{{ name }}</td>
                                  <td>{{ date }}</td>
                                  <td>{{ editedItem.comment }}</td>
                                </tr>
                            </tbody>
                        </table>
                      </v-flex>
                    </v-layout>
                    <h3 class="font-weight-black primary--text mb-0">
                      {{ $t('viatics.generalData') }}
                    </h3>
                    <v-layout>
                      <v-flex v-if="editedIndex !== -1">
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.folio') }} :
                        </div>
                        <v-layout v-if="editedIndex !== -1">
                          <v-flex class="pr-5">
                            <v-text-field clearable class="mt-2" required :rules="rules.required" :error-messages="errors.folio" v-model="editedItem.folio" :disabled="true" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex md3>
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.requestDate') }} :
                        </div>
                        <v-layout>
                          <v-flex class="pr-5">
                            <v-text-field clearable class="mt-2" required :rules="rules.required" :error-messages="errors.creation_date" v-model="editedItem.creation_date" :disabled="true" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex md3>
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.user') }} :
                        </div>
                        <v-text-field clearable class="mt-2 pr-5" required :rules="rules.required" :error-messages="errors.name" v-model="editedItem.user.name" :disabled="true" />
                      </v-flex>
                      <v-flex md6>
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.travelPeriod') }} :
                        </div>
                        <v-layout>
                          <v-flex class="pr-5">
                            <v-menu v-model="menuApproved" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" >
                              <template v-slot:activator="{ on }">
                                <v-text-field class="mt-2" required :rules="rules.required" :error-messages="errors.startDate" v-model="editedItem.start_date" :label="$t('viatics.from')" prepend-icon="event" readonly :disabled="editDates && editedIndex !== -1" v-on="on" ></v-text-field>
                              </template>
                              <v-date-picker :max="editedItem.end_date" color="primary" v-model="editedItem.start_date" @input="menu = false" :locale="$t('history.local')"></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex>
                            <v-menu v-model="menu2Approved" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field class="mt-2" required :rules="rules.required" v-model="editedItem.end_date" :error-messages="errors.endDate" :label="$t('viatics.to')" prepend-icon="event" readonly v-on="on" :disabled="editDates && editedIndex !== -1"></v-text-field>
                              </template>
                              <v-date-picker color="primary" v-model="editedItem.end_date" @input="menu2Approved = false" :min="editedItem.start_date" :locale="$t('history.local')" >
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <span v-if="status === 'CREATED' && editedItem.status === null">
                      <div class="subtitle-1 mt-2">
                        {{ $t('general.orderNumber') }} :
                      </div>
                      <v-layout>
                        <v-flex md12>
                          <v-text-field v-model="editedItem.order_number" class="pt-0 mt-0" persistent-hint type="text"/>
                        </v-flex>
                      </v-layout>
                    </span>
                    <div class="subtitle-1 mt-2">
                      {{ $t('general.project') }} :
                    </div>
                    <v-layout>
                      <v-flex md12>
                        <v-autocomplete class="pt-0 mt-0" v-model="editedItem.project_id" item-text="name" item-value="id" persistent-hint :rules="rules.required" :items="projects" :disabled="editProject && editedIndex !== -1" />
                      </v-flex>
                      <v-flex md1 v-if="editedIndex !== -1 && status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED' && viewDetails === false">
                        <v-btn icon small :color="editProject ? 'primary' : 'grey'" @click="editProject = !editProject">
                          <v-icon small>{{ editProject ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <div class="subtitle-1 pb-0 mb-0">
                      {{ $t('general.description') }} :
                    </div>
                    <v-layout>
                      <v-flex md12>
                        <v-textarea class="pt-0 mt-0" v-model="editedItem.description" :error-messages="errors.description" :disabled="editDescription && editedIndex !== -1" auto-grow rows="1"></v-textarea>
                      </v-flex>
                      <v-flex md1 v-if="editedIndex !== -1 && status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED' && viewDetails === false">
                        <v-btn icon small :color="editDescription ? 'primary' : 'grey'" @click="editDescription = !editDescription" >
                          <v-icon small>{{ editDescription ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout class="pr-5">
                      <v-flex class="pa-0" md11>
                        <v-checkbox class="mb-0 pb-0" v-model="editedItem.is_travel" :error-messages="errors.is_travel" :disabled="editIsTravel && editedIndex !== -1" :label="$t('viatics.travelQuestion')"></v-checkbox>
                      </v-flex>
                      <v-flex md1 v-if="editedIndex !== -1 && status === 'CREATED' && editedItem.is_travel || editedIndex !== -1 && status === 'REJECTED' && editedItem.is_travel && viewDetails === false">
                        <v-btn icon small :color="editIsTravel ? 'primary' : 'grey'" @click="editIsTravel = !editIsTravel" :disabled="!editedItem.is_travel">
                          <v-icon small>{{ editIsTravel ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex md4>
                        <div v-if="editedItem.is_travel" class="subtitle-1 mt-2" >
                          {{ $t('viatics.travelType') }}
                          <span
                            md1 v-if="editedIndex !== -1 && status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED' && editedItem.is_travel && viewDetails === false">
                            <v-btn icon small v-if="editedItem.is_travel" :color="editTravelType ? 'primary' : 'grey'" @click="editTravelType = !editTravelType">
                              <v-icon small>{{ editTravelType ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                            </v-btn>
                          </span>
                          :
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div v-if="editedItem.is_travel" class="subtitle-1 mt-2">
                          {{ $t('viatics.origin') }}
                          <span md1 v-if=" editedIndex !== -1 && status === 'CREATED' && editedItem.is_travel || editedIndex !== -1 && status === 'REJECTED' && editedItem.is_travel && viewDetails === false">
                            <v-btn icon small :color="editOrigin ? 'primary' : 'grey'" @click="editOrigin = !editOrigin">
                              <v-icon small>{{ editOrigin ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                            </v-btn>
                          </span>
                          :
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div v-if="editedItem.is_travel" class="subtitle-1 mt-2">
                          {{ $t('viatics.destination') }}
                          <span md1 v-if="editedIndex !== -1 && status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED' && viewDetails === false">
                            <v-btn icon small :color="editDestination ? 'primary' : 'grey'" @click="editDestination = !editDestination">
                              <v-icon small>{{ editDestination ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                            </v-btn>
                          </span>
                          :
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="editedItem.is_travel">
                      <v-flex md4>
                        <v-autocomplete class="pr-5 mt-0 pt-0 ajuste" v-model="editedItem.travel_type.id" item-text="name" item-value="id" :items="travelTypes" :disabled="editTravelType && editedIndex !== -1"/>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field class="pr-5 mt-0 pt-0" clearable :error-messages="errors.origin" v-model="editedItem.origin" :disabled="editOrigin && editedIndex !== -1"/>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field clearable class="mt-0 pt-0" :error-messages="errors.destination" v-model="editedItem.destination" :disabled="editDestination && editedIndex !== -1"/>
                      </v-flex>
                    </v-layout>
                    <!-- datos del vehiculo -->
                    <v-layout>
                      <v-flex class="pa-0" md11>
                        <v-checkbox class="mb-0 pb-0" v-model="editedItem.is_vehicle" :disabled="editIsTravel && editedIndex !== -1" :label="$t('viatics.vehicleQuestion')">
                        </v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if=" editedItem.fuelRequests.length > 0 && editedItem.is_vehicle">
                      <v-flex md3>
                        <v-autocomplete class="pr-5 mt-0 pt-0 ajuste" v-model="editedItem.fuelRequests[0].gst_vehicle_id" :label="$t('general.vehicle')" item-text="name" item-value="id" :items="vehicles" :disabled=" editTravelType && editedIndex !== -1 && status !== 'APPROVED'"/>
                      </v-flex>
                      <v-flex md3>
                        <v-text-field class="pr-5 mt-0 pt-1" disabled :label="$t('general.licensePlate')" :error-messages="errors.origin" v-model="getLicencePlate"/>
                      </v-flex>
                      <v-flex md3>
                        <v-text-field class="pr-5 mt-0 pt-0 ajuste" v-model="editedItem.fuelRequests[0].initial_milleage" :label="$t('general.initialMileage')" type="number" step="1" :disabled=" editedIndex !== -1 && status !== 'APPROVED'"/>
                      </v-flex>
                      <v-flex md3>
                        <v-text-field class="pr-5 mt-0 pt-0 ajuste" v-model="editedItem.fuelRequests[0].fuel_liters" :label="$t('general.litersOfGasoline')" type="number" step="1" :disabled=" editedIndex !== -1 && status !== 'APPROVED'"/>
                      </v-flex>
                      <v-flex md3>
                        <v-text-field value="0" class="pr-5 mt-0 pt-0 ajuste" :label="$t('general.finalMileage')" type="number" step="1" :disabled=" editedIndex !== -1 && status !== 'APPROVED'"/>
                      </v-flex>
                      <v-flex md3>
                        <v-text-field value="0" class="pr-5 mt-0 pt-0 ajuste" :label="$t('general.finalLitersOfGasoline')" type="number" step="1" :disabled=" editedIndex !== -1 && status !== 'APPROVED'"/>
                      </v-flex>
                      <v-btn @click="put" depressed color="primary" v-if="editedIndex !== -1 && status === 'APPROVED'">{{ $t('general.save') }}</v-btn>
                    </v-layout>
                    <v-layout v-if=" editedItem.is_vehicle && editedItem.fuelRequests.length > 0">
                      <v-flex md12>
                        <v-textarea :disabled="editTravelType && editedIndex !== -1" v-model="editedItem.fuelRequests[0].description" label="Descripción de viaje" :error-messages="errors.comment" rows="2"></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- CATEGORY -->
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">
                      {{ $t('general.categories') }}
                      <span md1 v-if="editedIndex !== -1 && status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED' && viewDetails === false">
                        <v-btn icon small :color="editCategories ? 'primary' : 'grey'" @click="editCategories = !editCategories">
                          <v-icon small>{{ editCategories ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                        </v-btn>
                      </span>
                    </h3>
                    <v-layout>
                      <v-flex v-if="categoryRulesAlert === true">
                        <v-alert :value="true" color="error" icon="warning" outline dense>
                          <span class="h6">
                            {{ $t('viatics.validationCategoryRequiredAlert') }}
                          </span>
                        </v-alert>
                      </v-flex>
                      <v-flex class="text-right">
                        <v-btn color="primary" @click="addCategorie" :disabled="editCategories && editedIndex > -1">{{ $t('viatics.addCategorie') }}</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-form lazy-validation ref="categoriesForm" v-model="categoriesForm">
                        <!-- DATA TABLE CATEGORIAS -->
                        <v-data-table :headers="categoriesHeader" :items="categoriesSelected" :loading="loadTableCategories" loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" :pagination.sync="pagination2" :rows-per-page-items="[10, 15, 25]" disable-pagination hide-actions>
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="max-width: 160px">
                                <v-autocomplete class="text-sm-center" v-model="props.item.categories_id" item-text="name" item-value="id" dense hide-details :rules="rules.required" :items="categories" chips small-chips color="primary" :disabled="editCategories && editedIndex !== -1"/>
                              </td>
                              <td>
                                <v-text-field outlined dense :hide-details="true" class="text-sm-center" color="primary" v-model="props.item.price" min="0" type="number" :rules="rules.positiveNumber" @change="getAmount(props.item, props.index)" :disabled="editCategories && editedIndex !== -1"/>
                              </td>
                              <td class="text-sm-center">
                                <v-text-field class="text-sm-center" outlined dense :hide-details="true" color="primary" v-model="props.item.quantity" min="0" type="number" :rules="rules.positiveNumber" :disabled="editCategories && editedIndex !== -1" @change="getAmount(props.item, props.index)"/>
                              </td>
                              <td class="text-sm-center text-truncate">
                                <v-textarea rows="1" auto-grow class="text-sm-center" outlined dense :hide-details="true" color="primary" v-model="props.item.comment" type="text" :disabled="editCategories && editedIndex !== -1"/>
                              </td>
                                <td>
                                <v-text-field outlined dense :hide-details="true" :disabled="editCategories && editedIndex !== -1" class="text-sm-center" color="primary" v-model="props.item.number_people" min="0" type="number" :rules="rules.positiveNumber"/>
                              </td>
                              <td>
                                <v-menu v-model="props.item.start" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                  <template v-slot:activator="{ on }">
                                    <v-text-field clearable required hide-details :rules="rules.required" :error-messages="errors.start_date" v-model="props.item.start_date" :label="$t('general.startDate')" :disabled="editCategories && editedIndex !== -1 || !editedItem.start_date || !editedItem.end_date" readonly v-on="on"></v-text-field>
                                  </template>
                                  <v-date-picker color="primary" :locale="$t('general.locale')" v-model="props.item.start_date" :min="editedItem.start_date || props.item.end_date && props.item.end_date" :max="editedItem.end_date || props.item.end_date ? props.item.end_date : null" @input="props.item.start = false" @change="changeDateEndCategory(props.item, props.index)"></v-date-picker>
                                </v-menu>
                              </td>
                              <td>
                                <v-menu v-model="props.item.end" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                  <template v-slot:activator="{ on }">
                                    <v-text-field clearable required hide-details :rules="rules.required" :error-messages="errors.start_date" v-model="props.item.end_date" :label="$t('general.endDate')" :disabled="editCategories && editedIndex !== -1 || !editedItem.start_date || !editedItem.end_date" readonly v-on="on"></v-text-field>
                                  </template>
                                  <v-date-picker color="primary" :locale="$t('general.locale')" v-model="props.item.end_date" :min="editedItem.start_date || props.item.start_date ? props.item.start_date : null" :max="editedItem.end_date" @input="props.item.end = false"></v-date-picker>
                                </v-menu>
                              </td>
                                <td
                                  class="text-sm-center"
                                >
                                <v-text-field
                                  class="text-sm-center mb-1"
                                  outlined
                                  dense
                                  :hide-details="true"
                                  color="primary"
                                  v-model="props.item.amount"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                  type="number"
                                  min="0"
                                  :rules="rules.required"
                                />
                              </td>
                                <td
                                  class="text-sm-center"
                                >
                                <v-btn
                                  @click="deleteCategorie(props.index)"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                  icon
                                >
                                    <v-icon color="red">mdi-delete</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:footer>
                            <td colspan="6" class="text-sm-right">
                              <span
                                class="
                                  h6
                                  primary--text
                                  text-uppercase
                                  font-weight-black
                                "
                                >{{ $t('general.total') }}:</span
                              >
                            </td>
                            <td colspan="2" class="primary mt-2">
                              <span class="h6 font-weight-black white--text"
                                >{{ getTotal | formatCurrency }} MXN</span
                              >
                            </td>
                          </template>
                        </v-data-table>
                      </v-form>
                    </v-layout>
                    <v-layout>
                      <v-flex md4>
                        <!-- <v-checkbox
                          v-model="editedItem.has_advance"
                          :error-messages="errors.is_refund"
                          :disabled="editAdvance && editedIndex !== -1"
                          :label="$t('viatics.advanceQuestion')"
                        >
                        </v-checkbox> -->
                        <v-radio-group v-model="editedItem.has_advance" @change="changeAdvance">
                          <v-radio
                            :label="$t('general.pettyCashAmex')"
                            :value="`caja_chica`"
                            :disabled="viewDetails === true"
                          ></v-radio>
                          <v-radio
                            :label="$t('general.advanceExpense')"
                            :value="`anticipo`"
                            :disabled="viewDetails === true"
                          ></v-radio>
                          <v-radio
                            :label="$t('general.refund')"
                            :value="`reembolso`"
                            :disabled="viewDetails === true"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex md4>
                        <vue-dropzone
                          v-if="editedItem.id === null || (editedItem.attachments.length < 5 && editedItem.status === 'CREATED')"
                          ref="dropzone" id="dropzone" :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUpload"
                          :key="dropzoneKey">
                        </vue-dropzone>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          clearable
                          width="30px"
                          class="ml-3"
                          required
                          :rules="rules.required"
                          prepend-icon="attach_money"
                          :error-messages="errors.totalAmount"
                          min="0"
                          type="number"
                          v-model="editedItem.totalAmount"
                          :disabled="editTotalAmount && editedIndex !== -1"
                        />
                      </v-flex>
                      <v-flex
                        md4
                        v-if="editedIndex !== -1 && status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED' && viewDetails === false"
                      >
                        <v-btn
                          icon
                          small
                          :color="editTotalAmount ? 'primary' : 'grey'"
                          @click="editTotalAmount = !editTotalAmount"
                        >
                          <v-icon small>{{
                            editTotalAmount ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12>
                        <h3 class="primary--text font-weight-black">{{$t('expenses.files')}}:</h3>
                      </v-flex>
                      <v-flex v-if="editedItem.attachments.length > 0">
                        <v-btn v-for="file in editedItem.attachments" :key="file.id" color="primary" dark @click="watchFile(file.file)">
                          <v-icon left v-if="file.file.files_type_id === 9 || file.file.files_type_id === 12">fas fa-file-archive</v-icon>
                          <v-icon left v-else-if="file.file.files_type_id === 3">description</v-icon>
                          <v-icon left v-else>insert_photo</v-icon>
                          <h3 class="pb-0 mb-0">{{$t('expenses.file')}} {{file.file_id}}</h3>
                        </v-btn>
                      </v-flex>
                      <v-flex v-else-if="editedItem.id > 0">
                        <v-alert color="info" outline :value="true" icon="info"> {{$t('expenses.noFiles')}} </v-alert>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="false">
                      <v-flex md11>
                        <v-checkbox
                          v-model="editedItem.has_advance"
                          :error-messages="errors.is_refund"
                          :disabled="editAdvance && editedIndex !== -1"
                          :label="$t('viatics.advanceQuestion')"
                        >
                        </v-checkbox>
                        <v-text-field
                          v-if="editedItem.has_advance"
                          clearable
                          width="30px"
                          class="ml-3"
                          min="0"
                          required
                          :rules="rules.required"
                          :error-messages="errors.has_advance"
                          v-model="editedItem.advance"
                          :disabled="editAdvance && editedIndex !== -1"
                          type="number"
                        />
                      </v-flex>
                      <v-flex
                        md1
                        v-if="
                          editedIndex !== -1 &&
                          (status === 'CREATED' || status === 'IN_REVIEW' || editedIndex !== -1 && status === 'REJECTED' && viewDetails === false)
                        "
                      >
                        <v-btn
                          icon
                          small
                          :color="editAdvance ? 'primary' : 'grey'"
                          @click="editAdvance = !editAdvance"
                        >
                          <v-icon small>{{
                            editAdvance ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <div
                      v-if="
                        status === 'APPROVED' &&
                        parseFloat(editedItem.amount_authorized) > 0
                      "
                      class="subtitle-1 mt-2"
                    >
                      {{ $t('viatics.amountAuthorized') }}
                    </div>

                    <!-- INICIO AMPLIACIONES -->
                    <v-flex class="text-right">
                      <v-btn
                        v-if="
                          editedItem.status === 'APPROVED' &&
                          status !== 'IN_REVIEW' &&
                          showBtnAddExtension
                        "
                        color="primary"
                        depressed
                        @click="addExtension"
                        :disabled="
                          editedItem.gst_expense && editedItem.gst_expense.status === 2 ||
                          editedItem.status === 'APPROVED' && extensionHandlerValidation(editedItem)
                        "
                      >{{ $t('viatics.addExtras') }}
                      </v-btn>
                    </v-flex>
                    <v-flex class="d-flex flex-row" v-if="editedItem.status === 'APPROVED' && extensionHandlerValidation(editedItem)">
                      <v-spacer></v-spacer>
                      <v-alert
                        :value="true"
                        color="warning"
                        icon="priority_high"
                        outline
                        dense
                      >
                        <span class="h6"
                        >
                          {{ $t('viatics.validationExtensionAlert') }}
                        </span>
                      </v-alert>
                    </v-flex>
                    <v-flex class="d-flex flex-row" v-if="editedItem.gst_expense && editedItem.gst_expense.status === 2">
                      <v-spacer></v-spacer>
                      <v-alert
                        :value="true"
                        color="warning"
                        icon="priority_high"
                        outline
                        dense
                      >
                        <span class="h6"
                        >
                          {{ $t('viatics.warningAddExtension') }}
                        </span>
                      </v-alert>
                    </v-flex>
                    <!-- BOTONES -->
                    <section
                      v-for="(item, index) in editedItem.extensions"
                      :key="index"
                    >
                      <v-layout>
                        <v-flex v-if="categoryExtensionRulesAlert === true">
                          <v-alert
                            :value="true"
                            color="error"
                            icon="warning"
                            outline
                            dense
                          >
                            <span class="h6"
                            >
                              {{ $t('viatics.validationExtensionRequiredAlert') }}
                            </span>
                          </v-alert>
                        </v-flex>
                        <v-flex class="text-right">
                          <!-- AGREGAR CATEGORIA -->
                          <v-btn
                            v-if="item.status === ''"
                            color="primary"
                            @click="addCategorieExtension"
                            >{{ $t('viatics.addCategorie') }}</v-btn
                          >
                        </v-flex>
                      </v-layout>

                      <!-- Datos cabecera -->
                      <v-layout
                        class="d-flex justify-end"
                        v-if="editedItem.extensions.length > 0"
                      >
                        <v-flex md2 class="mr-3 text-center d-flex justify-content-center align-items-center"
                          v-if="item.folio"
                        >
                          <span>
                            {{ $t('viatics.extension') }} - No.{{ extensionNumberGenerator(item, editedItem.extensions) }}
                          </span>
                        </v-flex>
                        <v-flex md2 class="mr-3" v-if="item.folio">
                          <v-text-field
                            v-model="item.folio"
                            required
                            hide-details
                            :rules="rules.required"
                            :error-messages="errors.start_date"
                            :label="$t('general.folio')"
                            readonly
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW'
                            "
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex
                          md2
                          class="mr-3"
                          v-if="
                            item.status &&
                            (item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW')
                          "
                        >
                          <v-text-field
                            :value="getStatusSpanish(item.status)"
                            required
                            hide-details
                            :rules="rules.required"
                            :error-messages="errors.start_date"
                            :label="$t('general.status')"
                            readonly
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW'
                            "
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex md3 class="mr-3">
                          <v-text-field
                            v-model="item.current_date"
                            disabled
                            required
                            hide-details
                            :rules="rules.required"
                            :error-messages="errors.start_date"
                            :label="$t('general.startDate')"
                            readonly
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex md3>
                          <v-menu
                            v-model="item.end"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="item.end_date"
                                :error="endFieldError"
                                clearable
                                required
                                hide-details
                                :rules="rules.required"
                                :error-messages="errors.start_date"
                                :label="$t('general.endDate')"
                                :disabled="
                                  item.status === 'APPROVED' ||
                                  item.status === 'REJECTED' ||
                                  item.status === 'IN_REVIEW'
                                "
                                readonly
                                v-on="on"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.end_date"
                              color="primary"
                              :locale="$t('general.locale')"
                              :min="item.current_date"
                              @input="item.end = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>

                      <!-- TABLA DE AMPLIACIONES -->
                      <v-layout v-if="editedItem.extensions.length > 0">
                        <v-flex xs12>
                          <v-form
                            lazy-validation
                            ref="formExtensions"
                            v-model="extensionsValid"
                          >
                            <v-data-table
                              :headers="categoriesHeaderExtension"
                              :items="item.categories"
                              :loading="loadTableCategories"
                              loading-text="Cargando contenido"
                              :footer-props="{ 'items-per-page-options': [-1] }"
                              hide-default-footer
                              no-data-text="No hay datos que mostrar"
                              :pagination.sync="pagination2"
                              :rows-per-page-items="[10, 15, 25]"
                              disable-pagination
                              hide-actions
                            >
                              <template v-slot:items="props">
                                <tr>
                                  <td
                                    class="text-sm-left text-truncate" style="max-width: 160px"
                                  >
                                    <v-autocomplete
                                      class="ajuste"
                                      v-model="props.item.categories_id"
                                      item-text="name"
                                      item-value="id"
                                      hide-details
                                      :rules="rules.required"
                                      :items="categories"
                                      :disabled="
                                        item.status === 'APPROVED' ||
                                        item.status === 'REJECTED' ||
                                        item.status === 'IN_REVIEW' ||
                                        editedItemExtensions === true
                                      "
                                      chips
                                      small-chips
                                      color="primary"
                                    />
                                    <!-- {{ props.item.name }} -->
                                  </td>
                                  <td style="width: 50px padding: 0, margin: 0">
                                    <v-text-field
                                      outlined
                                      dense
                                      :hide-details="true"
                                      class="text-sm-center"
                                      color="primary"
                                      v-model="props.item.price"
                                      min="0"
                                      type="number"
                                      :rules="rules.positiveNumber"
                                      :disabled="
                                        item.status === 'APPROVED' ||
                                        item.status === 'REJECTED' ||
                                        item.status === 'IN_REVIEW' ||
                                        editedItemExtensions === true
                                      "
                                      @change="
                                        getAmountExtension(
                                          props.item,
                                          props.index
                                        )
                                      "
                                    />
                                  </td>
                                  <td
                                    style="width: 50px padding: 0, margin: 0"
                                    class="text-sm-center"
                                  >
                                    <v-text-field
                                      class="text-sm-center"
                                      outlined
                                      dense
                                      :hide-details="true"
                                      color="primary"
                                      v-model="props.item.quantity"
                                      min="0"
                                      type="number"
                                      :rules="rules.positiveNumber"
                                      :disabled="
                                        item.status === 'APPROVED' ||
                                        item.status === 'REJECTED' ||
                                        item.status === 'IN_REVIEW' ||
                                        editedItemExtensions === true
                                      "
                                      @change="
                                        getAmountExtension(
                                          props.item,
                                          props.index
                                        )
                                      "
                                    />
                                  </td>
                                  <td
                                    style="width: 50px padding: 0, margin: 0"
                                    class="text-sm-center text-truncate"
                                  >
                                    <v-textarea
                                      rows="1"
                                      auto-grow
                                      class="text-sm-center"
                                      outlined
                                      dense
                                      :hide-details="true"
                                      color="primary"
                                      v-model="props.item.comment"
                                      type="text"
                                      :disabled="
                                        item.status === 'APPROVED' ||
                                        item.status === 'REJECTED' ||
                                        item.status === 'IN_REVIEW' ||
                                        editedItemExtensions === true
                                      "
                                    />
                                  </td>
                                  <td style="width: 50px padding: 0, margin: 0">
                                    <v-text-field
                                      outlined
                                      dense
                                      :hide-details="true"
                                      :disabled="
                                        item.status === 'APPROVED' ||
                                        item.status === 'REJECTED' ||
                                        item.status === 'IN_REVIEW' ||
                                        editedItemExtensions === true
                                      "
                                      class="text-sm-center"
                                      color="primary"
                                      v-model="props.item.number_people"
                                      min="0"
                                      type="number"
                                      :rules="rules.positiveNumber"
                                    />
                                  </td>
                                  <td>
                                    <v-menu
                                      v-model="props.item.start"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      lazy
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          clearable
                                          required
                                          hide-details
                                          :rules="rules.required"
                                          :error-messages="errors.start_date"
                                          v-model="props.item.start_date"
                                          :label="$t('general.startDate')"
                                          :disabled="
                                            item.status === 'APPROVED' ||
                                            item.status === 'REJECTED' ||
                                            item.status === 'IN_REVIEW' ||
                                            editedItemExtensions === true ||
                                            !item.end_date
                                          "
                                          readonly
                                          v-on="on"
                                        >
                                        </v-text-field>
                                      </template>
                                      <v-date-picker
                                        color="primary"
                                        :locale="$t('general.locale')"
                                        v-model="props.item.start_date"
                                        :min="item.current_date || props.item.end_date && props.item.end_date"
                                        :max="props.item.end_date ? props.item.end_date : null || item.end_date"
                                        @input="props.item.start = false"
                                        @change="changeDateEndCategoryExtension(item.categories, props.item, props.index)"
                                      >
                                      </v-date-picker>
                                    </v-menu>
                                  </td>
                                  <td>
                                    <v-menu
                                      v-model="props.item.end"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      lazy
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          clearable
                                          required
                                          hide-details
                                          :rules="rules.required"
                                          :error-messages="errors.end_date"
                                          v-model="props.item.end_date"
                                          :label="$t('general.endDate')"
                                          :disabled="
                                            item.status === 'APPROVED' ||
                                            item.status === 'REJECTED' ||
                                            item.status === 'IN_REVIEW' ||
                                            editedItemExtensions === true ||
                                            !item.end_date
                                          "
                                          readonly
                                          v-on="on"
                                        >
                                        </v-text-field>
                                      </template>
                                      <v-date-picker
                                        color="primary"
                                        :locale="$t('general.locale')"
                                        v-model="props.item.end_date"
                                        :min="item.current_date || props.item.start_date ? props.item.start_date : null"
                                        :max="item.end_date"
                                        @input="props.item.end = false"
                                      >
                                      </v-date-picker>
                                    </v-menu>
                                  </td>
                                  <td
                                    style="width: 50px padding: 0, margin: 0"
                                    class="text-sm-center"
                                  >
                                    <v-text-field
                                      class="text-sm-center mb-1"
                                      outlined
                                      dense
                                      :hide-details="true"
                                      color="primary"
                                      v-model="props.item.amount"
                                      type="number"
                                      min="0"
                                      :disabled="
                                        item.status === 'APPROVED' ||
                                        item.status === 'REJECTED' ||
                                        item.status === 'IN_REVIEW' ||
                                        editedItemExtensions === true
                                      "
                                      :rules="rules.required"
                                    />
                                  </td>
                                  <td
                                    style="width: 50px padding: 0, margin: 0"
                                    class="text-sm-center"
                                  >
                                    <v-btn
                                      @click="deleteExtension(props.index, item.categories)"
                                      :disabled="
                                        item.status === 'APPROVED' ||
                                        item.status === 'REJECTED' ||
                                        item.status === 'IN_REVIEW' ||
                                        editedItemExtensions === true
                                      "
                                      icon
                                    >
                                      <v-icon color="red">mdi-delete</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                              </template>
                              <template v-slot:footer>
                                <td colspan="6" class="text-sm-right">
                                  <span
                                    class="
                                      h6
                                      primary--text
                                      text-uppercase
                                      font-weight-black
                                    "
                                    >{{ $t('general.total') }}:</span
                                  >
                                </td>
                                <td colspan="2" class="primary mt-2">
                                  <span class="h6 font-weight-black white--text"
                                    >{{
                                      getTotalExtensions(item) | formatCurrency
                                    }}
                                    MXN</span
                                  >
                                </td>
                              </template>
                            </v-data-table>
                          </v-form>
                        </v-flex>
                      </v-layout>

                      <!-- ÁREA DE BOTÓN DEBAJO DEL TOTAL DE LA TABLA DE CATEGORÍAS DE AMPLIACIONES -->
                      <v-layout>
                        <v-flex class="text-right">
                          <!-- GUARDAR AMPLIACIONES  -->
                          <v-btn
                            v-if="item.status === ''"
                            color="primary"
                            @click="saveExtensions(index)"
                            :disabled="editedItemExtensions === true"
                            >{{ $t('viatics.saveExtras') }}</v-btn
                          >
                          <v-btn
                            v-if="item.status === ''"
                            color="primary"
                            @click="cancelExtensions(index)"
                            :disabled="editedItemExtensions === false"
                            >{{ $t('general.cancel') }}</v-btn>
                        </v-flex>
                      </v-layout>

                      <!-- ANTICIPO -->
                      <v-layout
                        class="d-flex justify-end"
                        v-if="editedItem.extensions.length > 0"
                      >
                        <v-flex md9>
                          <v-checkbox
                            v-model="item.is_advance"
                            :true-value="1"
                            :false-value="0"
                            @change="calculateTotalExtensions"
                            :error-messages="errors.is_refund"
                            :label="$t('viatics.advanceQuestion')"
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW' ||
                              editedItemExtensions === true
                            "
                          >
                          </v-checkbox>
                        </v-flex>
                        <v-flex md3>
                          <v-text-field
                            v-if="item.is_advance"
                            clearable
                            width="30px"
                            class="ml-3"
                            min="0"
                            required
                            :rules="rules.required"
                            :error-messages="errors.has_advance"
                            v-model="item.amount_advance"
                            type="number"
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW' ||
                              editedItemExtensions === true
                            "
                          />
                        </v-flex>
                      </v-layout>

                      <v-layout
                        class="d-flex justify-end"
                        v-if="editedItem.extensions.length > 0"
                      >
                        <v-flex
                          md6
                          class="text-right"
                          v-if="
                            status === 'IN_REVIEW' &&
                            isValidator() &&
                            item.status === 'IN_REVIEW'
                          "
                        >
                          <v-btn
                            round
                            depressed
                            color="#73D673"
                            class="ma-2 white--text"
                            :loading="loadingChangeStatusExtension"
                            @click="showViaticsAceptedExtension(index)"
                          >
                            {{ $t('viatics.validateExtension') }}
                          </v-btn>
                          <v-btn
                            flat
                            color="#F7665E"
                            class="ma-2"
                            :loading="loadingChangeStatusExtension"
                            @click="
                              changeStatusExtension(
                                editedItem,
                                'REJECTED',
                                index
                              )
                            "
                          >
                            {{ $t('viatics.rejectExtension') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </section>
                    <!-- FIN AMPLIACIONES -->
                    <v-layout
                      v-if="
                        status === 'APPROVED' &&
                        parseFloat(editedItem.amount_authorized) > 0
                      "
                    >
                      <v-text-field
                        clearable
                        width="30px"
                        class="ml-3"
                        required
                        prepend-icon="attach_money"
                        :error-messages="errors.amount_authorized"
                        v-model="editedItem.amount_authorized"
                        min="0"
                        :disabled="true"
                      />
                    </v-layout>
                    <div v-if="status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED'" class="subtitle-1 mt-2">
                      {{ $t('viatics.validators') }}
                    </div>
                    <v-layout v-if="status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED'">
                      <v-flex md11>
                        <v-autocomplete
                          v-model="editedItem.validator_id"
                          item-text="name"
                          item-value="id"
                          required
                          :rules="rules.required"
                          :error-messages="errors.validator_id"
                          :items="filterValidators"
                          color="primary"
                          :disabled="editApprovers && editedIndex !== -1"
                          @change="changeRequestValidator"
                        />
                      </v-flex>
                      <v-flex
                        md1
                        v-if="editedIndex !== -1 && status === 'CREATED' || editedIndex !== -1 && status === 'REJECTED' && viewDetails === false"
                      >
                        <v-btn
                          icon
                          small
                          :color="editApprovers ? 'primary' : 'grey'"
                          @click="editApprovers = !editApprovers"
                        >
                          <v-icon small>{{
                            editApprovers ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <!-- TODO: SE QUITO POR PETICION -->
                    <!-- <v-layout v-if="status === 'REJECTED'">
                      <v-flex
                        xs12
                        class="pa-2 mt-3"
                        style="background-color: #f7665e; border-radius: 5px"
                      >
                        <v-icon small class="mb-1" color="#FFF"
                          >fas fa-thumbs-down</v-icon
                        >
                        <p>
                          <strong>{{ editedItem.comment }}</strong>
                        </p>
                      </v-flex>
                    </v-layout> -->
                    <!-- ANTICIPO -->
                      <!-- v-if="editedItem.extensions.length > 0" -->
                    <v-layout
                      class="d-flex justify-start my-4"
                      v-if="status === 'IN_REVIEW' || status === 'APPROVED'"
                    >
                      <v-flex md9>
                        <span
                          class="
                            h6
                            font-weight
                          "
                          >{{ $t('viatics.totalAmountAdvance') }}:</span
                        >
                        <span class="h6"
                        >
                          {{ advanceCalculate(editedItem, editedItem.amount_advance) | formatCurrency }} MXN
                        </span>
                      </v-flex>
                      <v-flex md3>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-5" v-if="editedIndex !== -1">
                      <v-flex>
                        {{ $t('viatics.downloadRequest') }}
                        <v-btn
                          class="mr-0"
                          :loading="loadingDownload === 'pdf'"
                          icon
                          flat
                          color="error"
                          @click="downloadRequest('pdf')"
                        >
                          <v-icon dark> mdi-file-pdf-box </v-icon>
                        </v-btn>
                        <v-btn
                          class="ml-0"
                          :loading="loadingDownload === 'xls'"
                          icon
                          flat
                          color="green"
                          @click="downloadRequest('xls')"
                        >
                          <v-icon dark> mdi-file-excel-box</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
            <!--/v-container-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{
                status === 'CREATED' || status === 'IN_REVIEW' || !isValidator() || status === 'APPROVED'
                  ? $t('general.cancel')
                  : $t('general.close')
              }}
            </v-btn>
            <!-- TODO: Se retira por historia #586 -->
            <!-- <v-btn
              v-if="
                status === 'IN_REVIEW' &&
                isValidator() &&
                !isApprovedAndExtensionReview(editedItem)
              "
              round
              depressed
              color="#73D673"
              class="ma-2 white--text"
              @click="confirmValidate(editedItem)"
            >
              {{ $t('viatics.validate') }}
            </v-btn>
            <v-btn
              v-if="
                status === 'IN_REVIEW' &&
                isValidator() &&
                !isApprovedAndExtensionReview(editedItem)
              "
              flat
              color="#F7665E"
              class="ma-2"
              @click="confirmReject(editedItem)"
            >
              {{ $t('viatics.reject') }}
            </v-btn> -->

            <v-menu
              open-on-hover top offset-y
              v-if="editedIndex !== -1 && status === 'REJECTED' && viewDetails === false"
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  round
                  class="white--text"
                  depressed
                >
                  {{ $t('general.actions') }}
                </v-btn>
              </template>
              <v-list two-line>
                <v-list-tile
                  avatar
                  @click="save()"
                  :disabled="loading"
                >
                  <v-list-tile-action>
                    <v-icon color="primary">mdi-content-save</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="$t('general.save')"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  avatar
                  @click="confirmSendToValidate(editedItem)"
                  :disabled="loading"
                >
                  <v-list-tile-action>
                    <v-icon color="primary">mdi-send</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="$t('viatics.saveAndSend')"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>

            <v-btn v-if="status === 'CREATED'" color="primary" round class="white--text" depressed :loading="loading" :disabled="loading" @click="save">
              {{ editedIndex !== -1 ? $t('general.save') : $t('general.create') }}
            </v-btn>
            <v-btn
              v-if="
                !isValidator() && status !== 'CREATED' && status !== 'IN_REVIEW' && status !== 'REJECTED' ||
                status === 'APPROVED' && status !== 'CREATED' && status !== 'IN_REVIEW' && status !== 'REJECTED'
              "
              color="primary"
              round
              class="white--text"
              depressed
              :loading="loadingSaveExtensions"
              :disabled="loadingSaveExtensions || editedItemExtensions === false"
              @click="sendExtensions"
            >
              {{ $t('general.submit') }}
            </v-btn>
            <!-- <v-btn
            v-if="status === 'CREATED'"
            color="primary"
            round
            class="white--text"
            depressed
            :loading="loading"
            :disabled="loading"
            @click="saveAndSend"
            >
              {{ $t('viatics.saveAndSend') }}
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('expenses.delete') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black">
              <span class="error--text">{{ $t('expenses.description') }}: </span
              >{{ editedItem.description }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="workflowDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.startWorkflow') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.startWorkflowQuestion') }}</p>
            <p class="font-weight-black">
              <span class="primary--text"
                >{{ $t('expenses.description') }}: </span
              >{{ editedItem.description }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="closeWorkflowDialog"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="doStartWorkflow"
            >
              {{ $t('expenses.start') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOGO DESCRIPCION ADICIONALES -->
      <v-dialog
        v-model="descriptionExtensionDialog"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('viatics.addDescription') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-textarea
              v-model="commentExtense.comment"
              :error-messages="errors.comment"
              :disabled="commentExtense.disabled || editedItemExtensions === true"
              rows="2"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              round
              flat
              @click="descriptionExtensionDialog = false"
              >{{ $t('general.cancel') }}</v-btn
            >
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="primary"
              round
              depressed
              @click="saveDescriptionDialogExtense"
              >{{ $t('general.accept') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogValidate" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('viatics.confirmTitle') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>
              {{ $t('viatics.validateQuestion')
              }}<strong>: {{ editedItem.folio }}</strong
              >{{ '?' }}
            </p>
            <p>
              {{ $t('viatics.requestedBy') }} :
              <span style="color: #1e3c72">{{ editedItem.user.name }}</span>
            </p>
            <p>{{ $t('viatics.validationDescription') }}:</p>
            <v-textarea v-model="validation.description" rows="2"></v-textarea>
            <v-flex>
              <p>{{ $t('viatics.amountAuthorized') }}:</p>
              <v-text-field
                clearable
                required
                prepend-icon="attach_money"
                :error-messages="errors.amount"
                v-model="validation.amount_authorized"
              />
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="dialogValidate = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="primary"
              round
              depressed
              @click="validateRequest()"
            >
              {{ $t('general.accept') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogReject" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('viatics.rejectTitle') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>
              {{ $t('viatics.rejectQuestion', { folio: editedItem.folio }) }}
            </p>
            <v-form lazy-validation ref="formReject" v-model="validFormReject">
              <v-textarea
                v-model="rejectDescription"
                :error-messages="errors.description"
                :rules="rules.required"
                rows="2"
              ></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="dialogReject = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="rejectRequest()"
            >
              {{ $t('viatics.reject') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('viatics.deleteTitle') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>
              {{ $t('viatics.deleteQuestion')
              }}<strong>: {{ editedItem.folio }}</strong
              >{{ '?' }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="dialogDelete = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deleteRequest()"
            >
              {{ $t('viatics.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogSend" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('viatics.confirmSendTitle') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>
              {{ $t('viatics.sendQuestion')
              }}<strong>: {{ editedItem.folio }}</strong
              >{{ '?' }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="dialogSend = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="primary"
              round
              depressed
              @click="sendRequest()"
            >
              {{ $t('general.accept') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- DIALOGO AGREGAR COMPROBACION -->
      <v-dialog v-model="dialogExpense" max-width="600px" persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ formExpenseTitle }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-form lazy-validation ref="formExpense" v-model="validExpense">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="start"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="editable"
                          clearable
                          required
                          :rules="rules.required"
                          :error-messages="errors.start_date"
                          v-model="editedExpenseItem.start_date"
                          :label="$t('general.startDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        :locale="$t('general.locale')"
                        v-model="editedExpenseItem.start_date"
                        :max="maxDate"
                        @input="start = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="end"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="editable"
                          clearable
                          required
                          :rules="rules.required"
                          v-model="editedExpenseItem.end_date"
                          :error-messages="errors.end_date"
                          :label="$t('general.endDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        :locale="$t('general.locale')"
                        v-model="editedExpenseItem.end_date"
                        :min="minDate"
                        @input="end = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-autocomplete
                      v-model="editedExpenseItem.project_id"
                      required
                      :rules="rules.required"
                      :error-messages="errors.project_id"
                      :label="$t('general.project')"
                      :items="projects"
                      item-value="id"
                      item-text="name"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-autocomplete v-if="hasMultiProjects" v-model="editedExpenseItem.project_list" multiple :error-messages="errors.project_id" :label="$t('general.projectSecond')" :items="projects" item-value="id" item-text="name"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :disabled="editable"
                      clearable
                      required
                      :rules="rules.required"
                      :error-messages="errors.description"
                      :label="$t('general.description')"
                      v-model="editedExpenseItem.description"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-radio-group v-model="type" row>
                      <v-radio v-if="pettyCashAmount" :disabled="isDisabledPettyCash" :label="$t('pettyCash.title')" value="pettyCash"></v-radio>
                      <v-radio v-if="amexCardAmount" :disabled="isDisabledAmexCard" :label="$t('amexCard.title')" value="amexCard"></v-radio>
                      <v-radio :disabled="isDisabledAdvance" :label="$t('general.advanceExpense')" value="advance"></v-radio>
                      <v-radio :disabled="isDisabledRefund" :label="$t('general.refund')" value="refund"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field
                      v-if="type === 'advance'"
                      :disabled="editable || isPettyCash"
                      clearable
                      required
                      prepend-icon="attach_money"
                      :rules="rules.digit"
                      :persistent-hint="true"
                      :label="
                        $t('general.advance') + $t('general.optionalField')
                      "
                      v-model="editedExpenseItem.advance"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md 12>
                    <v-checkbox
                      v-model="editedItem.has_request"
                      :error-messages="errors.has_request"
                      :label="$t('expenses.relateToRequest')"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="viatics.length > 0 && editedItem.has_request"
                  >
                    <v-autocomplete
                      v-model="editedExpenseItem.viatic_request_id"
                      :error-messages="errors.viatic_request_id"
                      :label="$t('viatics.title')"
                      :items="expenseRequest"
                      item-value="id"
                      item-text="folio"
                    >
                      <template slot="item" slot-scope="data">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-list-tile-content v-on="on">
                              <v-list-tile-title
                                v-html="data.item.folio"
                              ></v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                          <span>
                            <pre style="color: #ffffff"
                              >{{ $t('general.description') }}: {{
                                data.item.description
                              }}</pre
                            >
                            <pre style="color: #ffffff"
                              >{{ $t('general.date') }}: {{
                                data.item.creation_date
                              }}</pre
                            >
                            <pre style="color: #ffffff"
                              >{{ $t('general.amount') }}: $ {{
                                data.item.amount_advance
                              }} MXN</pre
                            >
                          </span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading || editable"
              @click="saveExpense"
            >
              {{ $t('general.create') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="histDialog" max-width="800px">
      <v-card>
        <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.tracking') }}
            </h2>
          </v-toolbar>
          <v-card-text v-if="actionsLoading">
            <v-layout>
              <v-flex class="text-center">
                <v-progress-circular color="primary" indeterminate size="50" />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text v-if="!actionsLoading">
            <v-layout wrap>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('viatics.folio') }} </span
                  >{{ histItem.folio }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.project') }} </span
                  >{{ histItem.project.name }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('viatics.requestDate') }} </span
                  >{{ histItem.creation_date }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('viatics.requester') }} </span
                  >{{ histItem.user.name }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-divider />
                <h3 class="primary--text font-weight-black">
                  {{ $t('expenses.progress') }}
                </h3>
                  <v-card flat color="grey lighten-3">
                    <v-layout>
                      <v-flex
                        class="text-center py-3 hist-steps white--text text-success"
                        xs8
                      >
                      <v-avatar class="mr-2" size="20" :color="'white'">
                          <v-icon class="font-weight-black" small>check</v-icon>
                        </v-avatar>
                        <span class="font-weight-black white--text my-3">{{ $t('expenses.exs.sented') }}</span>
                      </v-flex>
                      <v-divider vertical />
                      <v-flex
                        class="text-center py-3 hist-steps white--text text-success"
                        xs8
                      >
                      <v-avatar class="mr-2" size="20" :color="'white'">
                          <v-icon class="font-weight-black" small>check</v-icon>
                        </v-avatar>
                        <span class="font-weight-black white--text my-3">{{ $t('expenses.exs.validator') }}</span>
                      </v-flex>
                    </v-layout>
                  <v-divider class="my-0 primary" />
                  <v-layout>
                    <v-flex class="text-center pa-3" xs8>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.sented') }}:
                      </h3>
                      <ul>
                        <li class="text-sm-left">
                          {{ histItem.user.name + ' - ' + histItem.created_at }}
                        </li>
                      </ul>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex class="text-center pa-3" xs8>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.assignedvalidator') }}:
                      </h3>
                      <ul>
                      <li class="text-sm-left" v-for="validator in histItem.validators" :key="validator.user.name">
                        {{ validator.user.name + ' - ' + histItem.created_at }}
                      </li>
                      </ul>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
      </v-card>
      </v-dialog>
    </v-container>
    <ViaticsAceptedExtension
      v-if="dialogViaticsAceptedExtension"
      @cancel="dialogViaticsAceptedExtension = false"
      @aprovedExtension="changeStatusExtension"
      :dialog="dialogViaticsAceptedExtension"
      :item="editedItem"
      :index="indexExtensions"
    />
  </div>
</template>

<script>
/* eslint-disable */
import vue2Dropzone from 'vue2-dropzone'
import { library } from '@fortawesome/fontawesome-svg-core'

import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faThumbsUp, faThumbsDown)
export default {
  name: 'viaticRequestComponent',
  components: {
    vueDropzone: vue2Dropzone,
    'font-awesome-icon': FontAwesomeIcon,
    ViaticsAceptedExtension: () =>
      import('./viatics/ViaticsAceptedExtension.vue'),
  },
  data() {
    return {
      component : 'viaticRequest',
      confirmCopyRequestDialog: false,
      tabIndex: 0,
      indexExtensions: -1,
      showBtnAddExtension: true,
      dialogViaticsAceptedExtension: false,
      loadingChangeStatusExtension: false,
      loadingSaveExtensions: false,
      descriptionExtensionDialog: false,
      commentExtense: {
        disabled: false,
        index: null,
        comment: null,
      },
      showExtensions: false,
      vehicles: [],
      date: null,
      name: null,
      expenseRequest: [],
      editedExpenseItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false,
        project_list: []
      },
      defaultExpenseItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false,
        project_list: []
      },
      dialogExpense: false,
      loadingDownload: null,
      rejectDescription: '',
      validExpense: true,
      validation: {
        description: '',
        amount_authorized: 0,
      },
      dialogValidate: false,
      dialogReject: false,
      dialogSend: false,
      dialogDelete: false,
      status: 'CREATED',
      editTotalAmount: true,
      editDestination: true,
      editOrigin: true,
      editDates: true,
      editTravelType: true,
      editProject: true,
      editDescription: true,
      editCategories: true,
      editAdvance: true,
      editApprovers: true,
      editIsTravel: true,
      approvers: [],
      users: [],
      travelTypes: [],
      defaultSelectedItemCategories: {
        id: 0,
        description: '',
      },
      selectedItemApprovers: {
        id: 0,
        description: '',
      },
      defaultSelectedItemApprovers: {
        id: 0,
        comment: '',
      },
      commentDialog: false,
      categoriesForm: true,
      approversForm: true,
      loadTableCategories: false,
      loadTableApprobers: false,
      menuCreated: false,
      menuInReview: false,
      menuApproved: false,
      menuRejected: false,
      menu2Created: false,
      menu2InReview: false,
      menu2Approved: false,
      menu2Rejected: false,
      menuDateCreated: false,
      menuDateInReview: false,
      menuDateApproved: false,
      menuDateRejected: false,
      viaticSearch: '',
      dialogRequest: '',
      searchCreated: '',
      searchSented: '',
      searchReviewed: '',
      searchPayable: '',
      searchPayment: '',
      searchPaid: '',
      isPettyCash: false,
      isDisabledPettyCash: false,
      isDisabledAdvance: false,
      isDisabledRefund: false,
      isDisabledAmexCard: false,
      type: 'refund',
      errors: {},
      loading: false,
      loadingItems: true,
      histLoading: false,
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
      pagination2: {
        descending: false,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
      pagination3: {
        descending: false,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
      timeout: 3000,
      dialog: false,
      histDialog: false,
      removeDialog: false,
      workflowDialog: false,
      start: false,
      end: false,
      validCreated: true,
      validInReview: true,
      validApproved: true,
      validRejected: true,
      validFormReject: true,
      editedIndex: -1,
      editedExpenseIndex: -1,
      copyExpenseItem: {},
      editedItem: {
        folio: '',
        status: null,
        id: null,
        user: {
          id: 0,
          name: '',
        },
        creation_date: new Date().toLocaleDateString('en-CA'),
        start_date: '',
        end_date: '',
        travel_type: {
          id: null,
          name: '',
        },
        project_id: null,
        description: '',
        origin: '',
        destination: '',
        categories_id: [],
        validator_id: null,
        totalAmount: 0,
        approvers: null,
        validators: [],
        categories: [],
        extensions: [],
        fuelRequests: [
          {
            gst_vehicle_id: null,
            description: null,
            initial_milleage: 0,
            fuel_liters: 0,
            final_liters: 0,
            final_milleage: 0
          },
        ],
        has_advance: 'reembolso',
        is_travel: false,
        is_vehicle: false,
        amount_authorized: 0,
        amount_advance: 0,
        advance: 0,
        showAdvance: false,
        is_petty_cash: 0,
        comment: '',
        order_number: '',
        attachments:[],
      },
      categoriesSelected: [],
      defaultItem: {
        folio: '',
        status: null,
        id: null,
        user: {
          id: 0,
          name: '',
        },
        creation_date: new Date().toLocaleDateString('en-CA'),
        start_date: '',
        end_date: '',
        travel_type: {
          id: 0,
          name: '',
        },
        project_id: null,
        description: '',
        origin: '',
        destination: '',
        categories_id: [],
        validator_id: null,
        totalAmount: 0,
        approvers: null,
        validators: [],
        categories: [],
        extensions: [],
        fuelRequests: [
          {
            gst_vehicle_id: null,
            description: null,
            initial_milleage: 0,
            fuel_liters: 0,
            final_liters: 0,
            final_milleage: 0
          },
        ],
        has_advance: false,
        is_travel: false,
        is_vehicle: false,
        advance: 0,
        comment: '',
        attachments:[]
      },
      histItem: {
        id: '',
        folio: '',
        creation_date: '',
        project: {
          name: '',
        },
        user: {
          name: '',
        },
        progress: [],
        steps: [
          {
            status: 1,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
              {
                id: 2,
                name: 'fulano',
              },
            ],
          },
          {
            status: 2,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
            ],
          },
        ],
        validators: [
          {
            user: {
              name: 'Ejemplo Validador',
            }
          },
        ]
      },
      histSteps: {
        sented: [],
        reviewed: [],
        payable: [],
        paid: [],
      },
      userLogged: {},
      expenses: [],
      exCreated: [],
      exSented: [],
      exReviewed: [],
      exPayable: [],
      exPayment: [],
      exPaid: [],
      expensesStatus: [],
      validators: [],
      validatorsExpenses: [],
      workflowName: '',
      projects: [],
      categories: [],
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      isApproved: false,
      pendingValidators: [],
      viatics: [],
      propsTwo: {},
      typeRadio: '',
      editedItemExtensions: false,
      extensionsValid: true,
      categoryRulesAlert: false,
      categoryExtensionRulesAlert: false,
      actionsLoading: false,
      viewDetails: false,
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.defaultMaxFiles', { amount: '5', size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        resizeWidth: 1080,
        resizeHeight: 1080,
        resizeMethod: 'contain',
        resizeQuality: 0.8,
        paramName: 'path',
        acceptedFiles: 'jpeg,.jpg,.png,.pdf',
        maxFiles: 5,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          dirname: 'IMG_EXPENSES',
        },
      },
      filesId:[], 
      loadingFile: false,
      loadFile: false,
      dialogViewFile: false,
      dataURLFile: null,
      watchItem: {
        files_type_id: 0,
        id: 0,
        is_public: 0,
        user_id: 0
      },
      viewImg: false,
      dropzoneKey: 0,
      openExpenseDialog: true,
      addExpenseDialog: false
    }
  },
  computed: {
    pettyCashAmount() {
      if (!this.$store.state.userLogged.small_box) return 0;
  
      const found = this.$store.state.userLogged.small_box.find(x => x.type === 1)
      return found ? found.amount : 0
    },
    amexCardAmount() {
      if (!this.$store.state.userLogged.small_box) return 0

      const found = this.$store.state.userLogged.small_box.find(x => x.type === 2)
      return found ? found.amount : 0
    },
    hasMultiProjects(){
      if(this.$store.state.userLogged && this.$store.state.userLogged.company[0].features.find(x => x.name === 'MULTIPROJECTS')) return true
      
      return false
    },
    getLicencePlate() {
      const isVehicleSelected =
        this.editedItem.fuelRequests[0].gst_vehicle_id !== null

      if (isVehicleSelected) {
        return this.vehicles.find(
          (e) => e.id === this.editedItem.fuelRequests[0].gst_vehicle_id
        ).license_plate
      }

      return 'No ha seleccionado un vehículo'
    },
    headersFiltered() {
      let newHeaders = []
      if (this.status !== 'IN_REVIEW') {
        newHeaders = this.headers.filter(
          (header) => header.text !== this.$t('viatics.requester')
        )
      } else {
        newHeaders = this.headers
      }
      return newHeaders
    },
    editable() {
      if (this.editedExpenseIndex > -1) {
        if (
          this.editedExpenseItem.created_by &&
          this.editedExpenseItem.created_by.id !==
            this.$store.state.userLogged.id
        ) {
          return true
        } else {
          return false
        }
      }
    },
    formExpenseTitle() {
      return this.editedExpenseIndex === -1
        ? this.$t('expenses.new')
        : this.$t('expenses.edit')
    },
    filterViatics() {
      let filtered = []
      if (this.status === 'IN_REVIEW' && this.isValidator()) {
        const response = this.viatics.filter((viatic) => {
          if (viatic.status === 'IN_REVIEW') return true
          if (viatic.status === 'APPROVED' && viatic.extensions.length > 0) {
            for (let i = 0; i < viatic.extensions.length; i++) {
              if (viatic.extensions[i].status === 'IN_REVIEW') return viatic
            }
          }
        })

        return response
      }

      filtered = this.viatics.filter(
        (viatic) =>
          viatic.status === this.status &&
          viatic.project.company_id === this.userLogged.company[0].id
      )

      return filtered
    },
    filterValidators() {
      let arrayValidators = []
      let validators = this.validators.filter(
        (item) =>
          item.area.company_id === this.userLogged.company[0].id &&
          item.area.id === this.userLogged.area[0].id
      )
      validators.forEach((x) => {
        let validator = {}
        validator.id = x.id
        validator.name = x.user.name
        arrayValidators.push(validator)
      })
      return arrayValidators
    },
    getTotal() {
      let total = 0
      this.categoriesSelected.forEach((x) => {
        total +=
          x.amount !== undefined && x.amount !== undefined
            ? parseFloat(x.amount)
            : 0
      })
      return total
    },
    // getTotalExtensions() {
    //   let total = 0
    //   this.editedItem.extensions[0].categories.forEach((e) => {
    //     total += e.amount !== undefined ? parseFloat(e.amount) : 0
    //   })

    //   return total
    // },
    minDate() {
      let minDate = ''
      if (
        this.editedItem.start_date !== '' &&
        this.editedItem.start_date !== null
      ) {
        minDate = new Date(this.editedItem.start_date)
          .toISOString()
          .substr(0, 10)
      }
      return minDate
    },
    maxDate() {
      let maxDate = ''
      if (
        this.editedItem.end_date !== '' &&
        this.editedItem.end_date !== null
      ) {
        maxDate = new Date(this.editedItem.end_date).toISOString().substr(0, 10)
      }
      return maxDate
    },
    heading() {
      return this.$t('viatics.title')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fa fa-file-invoice-dollar fa-fw icon-color'
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('viatics.new')
        : this.status !== 'CREATED'
        ? this.$t('viatics.requestDetails')
        : this.$t('viatics.edit')
    },
    headers() {
      return [
        {
          text: this.$t('viatics.folio'),
          align: 'left',
          value: 'folio',
          sortable: true,
        },
        {
          text: this.$t('viatics.requester'),
          align: 'left',
          value: 'user.name',
          sortable: true,
        },
        {
          text: this.$t('viatics.requestDate'),
          align: 'center',
          value: 'creation_date',
          sortable: true,
        },
        {
          text: this.$t('general.period'),
          align: 'center',
          value: 'destination',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'left',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: '',
          sortable: true,
        },
        {
          text: this.$t('viatics.advanceAuthorized'),
          align: 'center',
          value: 'amount_authorized',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    headers2() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: this.$t('general.startDate'),
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: this.$t('general.endDate'),
          align: 'center',
          value: 'end_date',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'amount_advance',
          sortable: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
        },
      ]
    },
    categoriesHeader() {
      return [
        {
          text: this.$t('viatics.categoryHeader'),
          align: 'center',
          value: 'name',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.approxPrice'),
          align: 'center',
          value: 'price',
          sortable: false,
          fixed: true,
          width: '9%'
        },
        {
          text: this.$t('viatics.abbrQuantity'),
          align: 'center',
          value: 'quantity',
          sortable: false,
          fixed: true,
          width: '4%'
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false,
          fixed: true,
          width: '18%'
        },
        {
          text: this.$t('viatics.abbrNumberPeople'),
          align: 'center',
          value: 'number_people',
          sortable: false,
          fixed: true,
          width: '3%'
        },
        {
          text: 'Fecha inicio',
          align: 'center',
          value: 'start_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: 'Fecha fin',
          align: 'center',
          value: 'end_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false,
          fixed: true,
          width: '9%'
        },

        {
          text: 'Acciones',
          align: 'center',
          value: 'actions',
          sortable: false,
          fixed: true,
          width: '4%'
        },
      ]
    },
    categoriesHeaderExtension() {
      return [
        {
          text: this.$t('viatics.categoryHeader'),
          align: 'center',
          value: 'name',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.approxPrice'),
          align: 'center',
          value: 'price',
          sortable: false,
          fixed: true,
          width: '9%'
        },
        {
          text: this.$t('viatics.abbrQuantity'),
          align: 'center',
          value: 'quantity',
          sortable: false,
          fixed: true,
          width: '4%'
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false,
          fixed: true,
          width: '18%'
        },
        {
          text: this.$t('viatics.abbrNumberPeople'),
          align: 'center',
          value: 'number_people',
          sortable: false,
          fixed: true,
          width: '3%'
        },
        {
          text: this.$t('viatics.dateStart'),
          align: 'center',
          value: 'start_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.dateEnd'),
          align: 'center',
          value: 'end_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false,
          fixed: true,
          width: '9%'
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false,
          fixed: true,
          width: '4%'
        }
      ]
    },
    approversHeader() {
      return [
        {
          text: this.$t('viatics.approber'),
          align: 'center',
          value: 'name',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.approberComment'),
          align: 'center',
          value: 'comment',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.approberDate'),
          align: 'center',
          value: 'date',
          sortable: false,
          fixed: true,
        },
      ]
    },
    rules() {
      return this.$validationRules()
    },
    endFieldError() {
      return !this.editedItem.extensions[0].end_date;
    }
  },
  watch: {
    getTotal() {
      this.editedItem.totalAmount = this.getTotal
    },
    // dialog (val) {
    //   val || this.close()
    // },
    // validators() {
    //   this.getPendingValidators()
    // },
    removeDialog(val) {
      val || this.closeRemove()
    },
    userLogged() {
      this.get()
      this.$emit('getProjects', {
        id: this.userLogged.company[0].id,
        context: this,
      })
      this.$emit('getCategories', {
        id: this.userLogged.company[0].id,
        context: this,
      })
      this.editedItem.user.id = this.userLogged.id
      this.editedItem.user.name = this.userLogged.name
    },
    '$store.state.userLogged'() {
      this.getLogged()
    },
    expenses() {
      this.byCreated()
      this.bySented()
      this.byReviewed()
      this.byPayable()
      this.byPayment()
      this.byPaid()
    },
    type() {
      if (this.type === 'pettyCash') {
        this.editedItem.advance = ''
        this.editedItem.is_petty_cash = 1
      } else if (this.type === 'advance') {
        this.editedItem.is_petty_cash = 0
      } else if (this.type === 'refund') {
        this.editedItem.advance = ''
        this.editedItem.is_petty_cash = 0
      }
    },
    'editedItem.has_advance'(val) {
      if (val && this.editedIndex === -1) {
        this.editedItem.advance = this.editedItem.totalAmount
      } else if (!val && this.editedIndex === -1) {
        this.editedItem.advance = 0
      }
    },
    'editedItem.validator_id'() {
      // this.editedItem.validators = []
      this.changeRequestValidator()
    },
    'editedItem.categories_id'() {
      let index = 0
      let item = {}
      if (this.editedItem.categories_id.length > 0) {
        this.editedItem.categories_id.forEach((x) => {
          let category = this.categories.find(
            (c) => c.id === this.editedItem.categories_id[index]
          )
          if (
            category !== undefined &&
            this.categoriesSelected.find(
              (i) => i.categories_id === category.id
            ) === undefined
          ) {
            item.categories_id = category.id
            item.price = 0
            item.quantity = 0
            item.amount = 0
            item.name = category.name
            item.comment = ''
            this.categoriesSelected.push(item)
            this.editedItem.categories = this.categoriesSelected
          }
          index++
          item = {}
        })
      }
      let catSelected = this.categoriesSelected
      catSelected.forEach((x) => {
        if (
          this.editedItem.categories_id.find((c) => c === x.categories_id) ===
          undefined
        ) {
          this.categoriesSelected = this.categoriesSelected.filter(
            (i) => i.categories_id !== x.categories_id
          )
          this.editedItem.categories = this.categoriesSelected
        }
      })
    },
  },
  created() {
    this.init()
    // this.get()
    this.loadInitialData()
  },
  methods: {
    closeViewFile(){
      this.dialogViewFile = false
      this.loadFile = false
      this.dataURLFile = null
      this.watchItem = {
        files_type_id: 0,
        id: 0,
        is_public: 0,
        user_id: 0
      }
    },
    watchFile (item) {
      this.dialogViewFile = true
      this.watchItem = item
      this.loadFile = true
      if (item.files_type_id === 9 || item.files_type_id === 12) {
        this.$store.dispatch('getZip', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      } else {
        this.$store.dispatch('getFile', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      }
    },
    fileAdded(file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg' || fileType === 'image/jpg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUploadError(file, message, xh) {
      this.showNotification(message + '. ' +  this.$t('dropzone.limitedFiles', { nameFile: file.name }), 'error', -1)
    },
    fileUpload(file, response) {
      if(this.filesId.length < 5) return this.filesId.push(response.data.id)
      const fileName = response.data.path.split('/').pop();
      this.showNotification(this.$t('dropzone.limitedFiles', { nameFile: fileName }), 'error', -1)
    },
    addFiles(){
      this.$emit('postFileByExpensesRequest', {
        idExpenseRequest: this.editedItem.id,
        filesId:this.filesId,
        user: this.userLogged,
        context: this,
      })
    },
    async loadInitialData() {
    await this.$emit('get', { id: this.itemId, context: this });
    },
    advanceCalculate (item, amount_advance) {
      const extensions = item.extensions
      const amountAdvance = amount_advance
      let total = 0
      if (extensions && extensions.length > 0) {
        const sum = extensions.reduce((a, b) => +a + +b.amount_authorized, 0);
        total = +sum + +amountAdvance
      } else {
        total = amountAdvance
      }
      return total
    },
    advanceAuthorizedCalculate (item, amount_authorized) {
      const extensions = item.extensions
      const amountAdvance = amount_authorized
      let total = 0
      if (extensions && extensions.length > 0) {
        const sum = extensions.reduce((a, b) => +a + +b.amount_authorized, 0);
        total = +sum + +amountAdvance
      } else {
        total = amountAdvance
      }
      return total
    },
    changeAdvance(event) {
      if (event === 'caja_chica') {
        this.editedItem.is_petty_cash = 1
        this.editedItem.advance = false
        this.editedItem.amount_advance = 0
        this.editedItem.showAdvance = false
      }
      if (event === 'anticipo') {
        let total = 0
        this.categoriesSelected.forEach((x) => {
          total +=
            x.amount !== undefined && x.amount !== undefined
              ? parseFloat(x.amount)
              : 0
        })
        this.editedItem.is_petty_cash = 0
        this.editedItem.advance = true
        this.editedItem.amount_advance = total
        this.editedItem.showAdvance = true
      }

      if (event === 'reembolso') {
        this.editedItem.is_petty_cash = 0
        this.editedItem.advance = false
        this.editedItem.amount_advance = 0
        this.editedItem.showAdvance = false
      }
    },
    getStatusSpanish(status) {
      if (status === 'APPROVED') return 'Aprobado'
      if (status === 'REJECTED') return 'Rechazado'
      if (status === 'IN_REVIEW') return 'En revisión'
    },
    init() {
      this.getLogged()
      this.isValidator()
      this.$emit('getVehicles', { context: this })
    },
    isApprovedAndExtensionReview(viatic) {
      if (
        viatic.status === 'IN_REVIEW' &&
        viatic.project.company_id === this.userLogged.company[0].id
      ) {
        for (let i = 0; i < viatic.extensions.length; i++) {
          if (viatic.extensions[i].status === 'IN_REVIEW') return true
        }
      }
      return false
    },
    getTotalExtensions(item) {
      let total = 0
      item.categories.forEach((e) => {
        total += e.amount !== undefined ? parseFloat(e.amount) : 0
      })

      return total
    },
    showViaticsAceptedExtension(index) {
      this.indexExtensions = index
      this.dialogViaticsAceptedExtension = true
    },
    changeStatusExtension(item, status, index, amount_authorized = 0) {
      this.dialogViaticsAceptedExtension = false
      const extension = item.extensions[index].id
      this.$emit('changeStatusExtension', {
        context: this,
        extension,
        payload: {
          status,
          amount_authorized,
          index,
        },
      })
    },
    calculateTotalExtensions(event) {
      if (event === 0) {
        this.editedItem.extensions[0].amount_advance = 0
        return
      }

      if (event === 1) {
        let total = 0
        this.editedItem.extensions[0].categories.forEach((e) => {
          const subtotal = e.quantity * e.price
          total += subtotal
        })
        this.editedItem.extensions[0].amount_advance = total
      }
    },
    addExtension() {
      let current_date = this.editedItem.end_date

      if (this.editedItem.extensions.length > 0) {
        // const lastItemIndex = this.editedItem.extensions.length - 1
        // current_date = this.editedItem.extensions[lastItemIndex].end_date
        current_date = this.editedItem.extensions[0].end_date
      }

      this.showBtnAddExtension = false
      const payload = {
        end_date: '',
        current_date,
        is_advance: 1,
        amount_advance: 0,
        status: '',
        categories: [
          {
            categories_id: null,
            price: 0,
            quantity: 0,
            comment: '',
            amount: 0,
            start_date: '',
            end_date: '',
            number_people: '0',
          },
        ],
      }

      this.editedItem.extensions.unshift(payload)
    },
    addCategorieExtension() {
      const categorie = {
        categories_id: null,
        price: 0,
        quantity: 0,
        comment: '',
        amount: 0,
        start_date: '',
        end_date: '',
        number_people: '0',
      }
      this.editedItem.extensions[0].categories.push(categorie)
    },
    changeDate(event, type, props) {
      const index = this.categoriesSelected.findIndex(
        (e) => e.id === props.item.id
      )
      // if(type === 'start') {
      //   this.categoriesSelected[index].start_date = event
      // }
    },

    deleteCategorie(index) {
      this.categoriesSelected.splice(index, 1)
    },
    deleteExtension (index, categories) {
      categories.splice(index, 1)
      if (this.editedItem.extensions[0].is_advance) {
        let total = 0
        this.editedItem.extensions[0].categories.forEach((e) => {
          total += e.amount !== undefined ? parseFloat(e.amount) : 0
        })
        this.editedItem.extensions[0].amount_advance = total
      } else {
        this.editedItem.extensions[0].amount_advance = 0
      }
    },
    addCategorie() {
      const item = {}
      item.start = false
      item.end = false
      item.categories_id = null
      item.price = 0
      item.quantity = 0
      item.amount = 0
      // item.name = null;
      item.start_date = null
      item.end_date = null
      item.comment = ''

      this.categoriesSelected.push(item)
    },
    closeConfirmCopyRequestDialog(){
      this.copyExpenseItem = {}
      this.confirmCopyRequestDialog = false
    },
    confirmCopyExpense(item){
      this.copyExpenseItem = item
      this.confirmCopyRequestDialog = true
    },
    copyExpense(){
      this.confirmCopyRequestDialog = false
      let item = this.copyExpenseItem
      this.tabIndex = 0
      this.status = 'CREATED'
      this.editedItem.start_date = item.start_date
      this.editedItem.end_date = item.end_date
      this.editedItem.order_number = item.order_number 
      this.editedItem.project_id = item.project_id
      this.editedItem.description = item.description
      this.editedItem.is_travel = item.gst_travel_type_id !== null ? true : false
      this.editedItem.travel_type = item.travel_type
      this.editedItem.origin = item.origin 
      this.editedItem.destination = item.destination

      if (item.fuel_requests.length > 0) {
        this.editedItem.is_vehicle = true
        this.editedItem.fuelRequests = item.fuel_requests
        item.fuel_requests[0].final_liters = this.editedItem.fuelRequests[0].final_liters = 0
        item.fuel_requests[0].final_milleage = this.editedItem.fuelRequests[0].final_milleage = 0
      }
      if (item.fuel_requests.length === 0) {
        this.editedItem.is_vehicle = false
        this.editedItem.fuelRequests = []
      }
      
      let categories = []
      item.categories.forEach((x) => {
        let itm = {}
        itm.id = x.id
        itm.categories_id = x.pivot.categories_id
        itm.name = x.name
        itm.quantity = x.pivot.quantity
        itm.price = parseFloat(x.pivot.price)
        itm.amount = x.pivot.amount
        itm.comment = x.pivot.comment
        this.categoriesSelected.push(itm)
        categories.push(x.id)
      })

      this.editedItem.categories = this.categoriesSelected
      this.editedItem.categories_id = categories

      this.editedItem.categories.forEach((e, index) => {
        e.start_date = item.categories[index].pivot && item.categories[index].pivot.start_date && item.categories[index].pivot.start_date.substr(0, 10)
        e.end_date = item.categories[index].pivot && item.categories[index].pivot.end_date && item.categories[index].pivot.end_date.substr(0, 10)
        e.id = item.categories[index].pivot.id
      })

      const typeRadio = this.hasAdvanceRadio(item)
      this.typeRadio = typeRadio
      this.editedItem.has_advance = typeRadio
      this.editedItem.validator_id = item.validators[0].user_id
      this.dialogRequest = true
    },
    createExpense(item) {
      this.editedExpenseItem.start_date = item.start_date
      this.editedExpenseItem.end_date = item.end_date
      this.editedExpenseItem.project_id = item.project_id
      this.editedExpenseItem.is_advance = item.advance
      const amountAuthorized = this.advanceAuthorizedCalculate(item, item.amount_authorized)
      this.editedExpenseItem.advance = item.advance === 1 ? amountAuthorized : 0
      this.editedExpenseItem.description = item.description
      this.editedExpenseItem.viatic_request_id = item.id
      this.editedItem.has_request = true
      
      if (item.advance === 1) this.type = 'advance'

      let request = this.viatics.find((x) => x.id === item.id)
      if (request !== undefined) {
        this.expenseRequest.push(request)
      }
      this.dialogExpense = true
    },
    downloadRequest(type) {
      this.loadingDownload = type
      this.$emit('downloadRequest', {
        context: this,
        item: this.editedItem,
        type,
      })
    },
    validateRequest() {
      this.$emit('validateRequest', {
        expensesRequest: this.editedItem.id,
        status: 'APPROVED',
        comment: this.validation.description,
        amount_authorized: this.validation.amount_authorized,
        context: this,
      })
    },
    rejectRequest() {
      if (this.$refs.formReject.validate()) {
        this.$emit('rejectRequest', {
          expensesRequest: this.editedItem.id,
          status: 'REJECTED',
          comment: this.rejectDescription,
          context: this,
        })
      }
    },
    deleteRequest() {
      if (this.status === 'CREATED') {
        this.loading = true
        this.$emit('deleteRequest', {
          expensesRequestD: this.editedItem.id,
          context: this,
        })
      }

      if (this.status === 'REJECTED') {
        this.$emit('deleteRequestRejected', {
          expensesRequestD: this.editedItem.id,
          context: this,
        })
        this.get('REJECTED')
      }
    },
    sendRequest() {
      this.loading = true
      this.$emit('sendRequest', {
        expensesRequest: this.editedItem.id,
        context: this,
      })

      if (this.status === 'REJECTED') {
        this.get('REJECTED')
      }
    },
    confirmValidate(item) {
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.validation.amount_authorized = parseFloat(item.amount_advance)
      this.dialogValidate = true
    },
    confirmReject(item) {
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.dialogReject = true
    },
    confirmDelete(item) {
      const itemDelete = { ...this.editedItem, ...item };
      this.editedItem = itemDelete
      this.dialogDelete = true
    },
    confirmSendToValidate(item) {
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.editedItem.fuelRequests = this.editedItem.fuel_requests
      this.dialogSend = true
    },
    showDescriptionDialogExtense(status, item, index) {
      this.commentExtense.index = index
      this.commentExtense.comment = item.comment
      this.commentExtense.disabled =
        status === 'APPROVED' || status === 'REJECTED' || status === 'IN_REVIEW'
      this.descriptionExtensionDialog = true
    },
    saveDescriptionDialogExtense() {
      this.editedItem.extensions[0].categories[
        this.commentExtense.index
      ].comment = this.commentExtense.comment
      this.descriptionExtensionDialog = false
    },
    showCommentDialog(item) {
      this.selectedItemApprovers.id = item.valdiators_id
      this.selectedItemApprovers.comment = item.comment
      this.commentDialog = true
    },
    getAmount(item) {
      let selectedItem = this.categoriesSelected.find(
        (x) => x.categories_id === item.categories_id
      )
      if (selectedItem !== undefined) {
        if (selectedItem.price > 0 && selectedItem.quantity === 0) {
          selectedItem.quantity = 1
        }
        let amount =
          parseFloat(selectedItem.quantity) * parseFloat(selectedItem.price)
        selectedItem.amount = amount
      }
      this.descriptionDialog = false
    },
    getAmount(item, index) {
      const amount = parseFloat(item.quantity) * parseFloat(item.price)
      this.categoriesSelected[index].amount = amount
      // let selectedItem = this.categoriesSelected.find(
      //   x => x.categories_id === item.categories_id
      // );
      // if (selectedItem !== undefined) {
      //   selectedItem.amount = amount;
      // }
    },
    changeDateEndCategory(item, index) {
      this.categoriesSelected[index].end_date = item.start_date
    },
    changeDateEndCategoryExtension(items, item, index) {
      items[index].end_date = item.start_date
    },
    getAmountExtension(item, index) {
      const amount = parseFloat(item.quantity) * parseFloat(item.price)
      this.editedItem.extensions[0].categories[index].amount = amount
      if (this.editedItem.extensions[0].is_advance) {
        let total = 0
        this.editedItem.extensions[0].categories.forEach((e) => {
          total += e.amount !== undefined ? parseFloat(e.amount) : 0
        })
        this.editedItem.extensions[0].amount_advance = total
      } else {
        this.editedItem.extensions[0].amount_advance = 0
      }
    },
    getLogged() {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    isValidator() {
      if (
        this.userLogged.validator &&
        this.userLogged.validator.validator_request.length > 0
      ) {
        return true
      } else {
        return false
      }
    },
    getValidador(item) {
      this.histItem = item
      this.histDialog = true
    },
    getHistory(item) {
      this.histLoading = true
      this.histItem = item
      this.histItem.progress = []
      this.$emit('getHistory', { id: item.id, context: this })
      this.$emit('getWorkflowValidatorApprover', {
        user_id: item.user.id,
        context: this,
      })
      this.$emit('getExpensesValidators', { id: item.id, context: this })
      this.histDialog = true
    },
    // getPendingValidators() {
    //   this.pendingValidators = this.validators
    //   this.histItem.progress.forEach((item) => {
    //     this.pendingValidators = this.pendingValidators.filter(
    //       (x) => x.validator.user_id !== item.user_id
    //     )
    //   })
    // },
    filterHistory() {
      if (this.histItem.progress.length > 0) {
        this.histSteps.sented = this.histItem.progress.filter(
          (item) => item.status === 'Enviado'
        )
        this.histSteps.reviewed = this.histItem.progress.filter(
          (item) => item.status === 'Revisado'
        )
        this.histSteps.payable = this.histItem.progress.filter(
          (item) => item.status === 'Aprobado'
        )
        this.histSteps.paid = this.histItem.progress.filter(
          (item) => item.status === 'Pagado'
        )
        if (this.histSteps.payable.length > 0) {
          this.isApproved = true
        }
      }
    },
    byCreated() {
      this.exCreated = this.expenses.filter(
        (item) => item.status_expense.id === 1
      )
    },
    bySented() {
      this.exSented = this.expenses.filter(
        (item) => item.status_expense.id === 2
      )
    },
    byReviewed() {
      this.exReviewed = this.expenses.filter(
        (item) => item.status_expense.id === 3
      )
    },
    byPayable() {
      this.exPayable = this.expenses.filter(
        (item) => item.status_expense.id === 4
      )
    },
    byPayment() {
      this.exPayment = this.expenses.filter(
        (item) => item.status_expense.id === 5
      )
    },
    byPaid() {
      this.exPaid = this.expenses.filter((item) => item.status_expense.id === 6)
    },
    checkFiscal(items) {
      var isNull = false
      items.forEach((item) => {
        if (item.subtotal === null) {
          isNull = true
        }
      })
      if (isNull) {
        return true
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        var count = 0
        if (item.gst_receipt_types_id === 1) {
          if (item.uuid !== null) {
            count += 0
          } else {
            count += 1
          }
        }
        if (count <= 0) {
          return false
        } else if (count > 0) {
          return true
        }
      }
    },
    detail(expenseId) {
      this.$router.push('/expenses/' + expenseId)
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    deleteItem(item) {
      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.removeDialog = true
    },
    removeItem() {
      this.loading = true
      this.delete()
    },
    closeRemove() {
      this.loading = false
      this.removeDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    closeCommentDialog() {
      this.commentDialog = false
    },
    close() {
      this.editedIndex = -1
      this.showBtnAddExtension = true
      this.loading = false
      this.errors = {}

      this.editedItem = Object.assign({}, this.defaultItem)
      this.histDialog = false
      this.histSteps = { sented: [], reviewed: [], payable: [], paid: [] }
      this.isPettyCash = false
      this.isDisabledPettyCash = false
      this.isDisabledRefund = false
      this.isDisabledAdvance = false
      this.type = 'refund'
      this.editedExpenseItem = Object.assign({}, this.defaultItem)
      this.editedItem.user.id = this.userLogged.id
      this.editedItem.user.name = this.userLogged.name
      this.categoriesSelected = []
      this.editedIndex = -1
      this.$refs.form.resetValidation()
      this.editTotalAmount = true
      this.editDestination = true
      this.editOrigin = true
      this.editDates = true
      this.editTravelType = true
      this.editProject = true
      this.editDescription = true
      this.editCategories = true
      this.editAdvance = true
      this.editApprovers = true
      this.editIsTravel = true

      this.expenseRequest = []

      this.dialogRequest = false
      this.dialogValidate = false
      this.dialogReject = false
      this.dialogDelete = false
      this.dialogSend = false
      this.dialogExpense = false
      this.editedItemExtensions = false
      this.filesId = []
      this.dropzoneKey++;
      this.dropzoneOptions.maxFiles = 5
      this.dropzoneOptions.dictDefaultMessage = this.$t('dropzone.defaultMaxFiles', { amount: '5', size: '5', unit: 'MB', })
    },
    editItem(item, isViewDetails = false) {
      if(isViewDetails) {
        this.viewDetails = isViewDetails
      } else {
        this.viewDetails = isViewDetails
      }
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = this.viatics.indexOf(item)
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.editedItem.creation_date = new Date(item.creation_date)
        .toISOString()
        .substr(0, 10)
      let categories = []
      item.categories.forEach((x) => {
        let itm = {}
        itm.id = x.id
        itm.categories_id = x.pivot.categories_id
        itm.name = x.name
        itm.quantity = x.pivot.quantity
        itm.price = parseFloat(x.pivot.price)
        itm.amount = x.pivot.amount
        itm.comment = x.pivot.comment
        this.categoriesSelected.push(itm)
        categories.push(x.id)
      })

      if (item.gst_travel_type_id !== null) {
        this.editedItem.is_travel = true
      } else {
        this.editedItem.is_travel = false
      }

      // Leer los datos del vehículo
      if (item.fuel_requests.length > 0) {
        this.editedItem.is_vehicle = true
        this.editedItem.fuelRequests = item.fuel_requests
        item.fuel_requests[0].final_liters = this.editedItem.fuelRequests[0].final_liters = 0
        item.fuel_requests[0].final_milleage = this.editedItem.fuelRequests[0].final_milleage = 0
      }
      if (item.fuel_requests.length === 0) {
        this.editedItem.is_vehicle = false
        this.editedItem.fuelRequests = []
      }


      const typeRadio = this.hasAdvanceRadio(item)
      this.typeRadio = typeRadio
      this.editedItem.has_advance = typeRadio
      // this.editedItem.has_advance = item.advance
      this.editedItem.advance = item.amount_advance
      this.editedItem.amount_authorized = item.amount_authorized
      this.editedItem.categories = this.categoriesSelected
      this.editedItem.categories_id = categories
      this.editedItem.comment =
        item.validators.length > 0 ? item.validators[0].pivot.comment : null
      this.date =
        item.validators.length > 0 ? item.validators[0].pivot.date : null
      this.name =
        item.validators.length > 0 && item.validators[0].user !== undefined
          ? item.validators[0].user.name
          : null
      let validators = []
      if (item.validators.length > 0) {
        item.validators.forEach((x) => {
          let validator = {}
          let user = this.users.find((u) => u.id === x.user_id)
          validator.id = x.pivot.id
          validator.validators_id = x.pivot.validators_id
          validator.name = user !== undefined ? user.name : ''
          validators.push(validator)
        })
        this.editedItem.validators = validators
      } else {
        this.editedItem.validators = []
      }
      this.editedItem.validator_id =
        validators.length > 0 ? validators[0].validators_id : []

      this.editedItem.categories.forEach((e, index) => {
        e.start_date = item.categories[index].pivot && item.categories[index].pivot.start_date && item.categories[index].pivot.start_date.substr(0, 10)
        e.end_date = item.categories[index].pivot && item.categories[index].pivot.end_date && item.categories[index].pivot.end_date.substr(0, 10)
        e.id = item.categories[index].pivot.id
      })

      this.editedItem.status = item.status

      // Leer ampliaciones
      if (item.extensions.length > 0) {
        // const extensions = item.extensions[0]
        const extensions = []

        item.extensions.forEach((e) => {
          const data = e
          const categories = data.categories.map((e) => {
            if (!e.pivot) {
              return e
            }
            return {
              id: e.id,
              name: e.name,
              core_company_id: e.core_company_id,
              default: e.default,
              categories_id: e.pivot.categories_id,
              id: e.pivot.id,
              number_people: e.pivot.number_people,
              price: e.pivot.price,
              quantity: e.pivot.quantity,
              comment: e.pivot.comment,
              start_date: new Date(e.pivot.start_date)
                .toISOString()
                .substr(0, 10),
              end_date: new Date(e.pivot.end_date).toISOString().substr(0, 10),
              amount: e.pivot.amount,
            }
          })

          data.categories = categories

          extensions.push(data)
        })

        this.editedItem.extensions = []
        this.editedItem.extensions = extensions
      }
      this.dialogRequest = true
      this.editedItem.attachments = item.attachments
      if(this.editedItem.attachments.length > 0) {
        // // incrementa la clave para forzar la recreación del componente
        this.dropzoneKey++;
        this.dropzoneOptions.maxFiles = this.editedItem.attachments.length > 4 ? 0 : (5 - this.editedItem.attachments.length) 
        this.dropzoneOptions.dictDefaultMessage = this.$t('dropzone.defaultMaxFiles', { amount: this.dropzoneOptions.maxFiles, size: '5', unit: 'MB', }),
        
        this.editedItem.attachments.forEach((item) =>{
          this.$store.dispatch('getFile', { event: { context: this, fileId: item.file_id }})
          item.dataURL = this.dataURL
        })
        
      }
    },
    saveExtensions(index) {
      this.categoryExtensionRulesAlert = false
      // if (this.$refs.formExtensions[index].validate()) return
      if (this.$refs.formExtensions[index].validate()) {
        this.editedItemExtensions = true
      }
      if (this.editedItem.extensions && this.editedItem.extensions.length > 0 && this.editedItem.extensions[0].categories.length === 0) {
        this.editedItemExtensions = false
        this.categoryExtensionRulesAlert = true
      }
    },
    sendExtensions() {
      // if (this.$refs.formExtensions[index].validate()) {
      // }
      this.$emit('saveExtensions', {
        context: this,
      })
    },
    cancelExtensions(index) {
      this.editedItemExtensions = false
    },
    save() {
      this.categoryRulesAlert = false
      let SelectedCategories = this.categoriesSelected
      if (SelectedCategories.length === 0) {
        this.categoryRulesAlert = true
        return
      }
      if (!this.$refs.categoriesForm.validate()) return
      // if (!this.$refs.extensionsForm.validate()) return
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        this.actionsLoading = true
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    saveExpense() {
      this.editedExpenseItem.has_multiprojects = this.editedExpenseItem.project_list && this.editedExpenseItem.project_list.length > 0
      if(this.editedExpenseItem.has_multiprojects && this.editedExpenseItem.project_list.length > 0 && !this.editedExpenseItem.project_list.find(x => x === this.editedExpenseItem.project_id)) this.editedExpenseItem.project_list.unshift(this.editedExpenseItem.project_id)
      
      this.errors = {}
      if (this.$refs.formExpense.validate()) {
        this.loading = true
        if (this.editedExpenseIndex > -1) {
          this.putExpense()
        } else {
          this.postExpense()
        }
      }
    },
    postExpense() {
      this.editedExpenseItem.has_advance = this.type
      this.$emit('postExpense', {
        item: this.editedExpenseItem,
        user: this.userLogged,
        context: this,
      })
    },
    putExpense() {
      this.$emit('putExpense', {
        item: this.editedExpenseItem,
        index: this.editedIndex,
        context: this,
      })
    },
    showWorkflowDialog(item) {
      this.workflowDialog = true
      this.editedItem = Object.assign({}, item)
    },
    closeWorkflowDialog() {
      this.workflowDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$refs.form.resetValidation()
      this.loading = false
    },
    doStartWorkflow() {
      this.loading = true
      this.startWorkflow()
    },
    getAcuse(id) {
      this.$emit('getAcuse', {
        id,
        context: this,
      })
    },
    get(status) {
      this.status = status !== undefined ? status : 'CREATED'
      this.loadingItems = true
      // if (this.status === 'IN_REVIEW' && this.isValidator()) {
      //   this.$emit('getByValidator', {
      //     context: this,
      //   })
      // } else if (this.status === 'IN_REVIEW' && !this.isValidator()) {
      //   this.$emit('getByUser', {
      //     context: this,
      //     user_id: this.userLogged.id,
      //     status: this.status,
      //   })
      // } else {
      //   this.$emit('get', {
      //     context: this,
      //   })
      // }

      if (this.status === 'IN_REVIEW') {
        this.$emit('getByUser', {
          context: this,
          user_id: this.userLogged.id,
          status: this.status,
        })
        return
      }

      this.$emit('get', {
        context: this,
      })
    },
    post() {
      // this.editedItem.categories.forEach(x => {
      //   delete x.name;
      // });
      this.editedItem.categories = this.categoriesSelected
      this.$emit('post', {
        item: this.editedItem,
        user: this.userLogged,
        context: this,
      })
    },
    put() {
      this.$emit('put', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    delete() {
      this.$emit('delete', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    startWorkflow() {
      this.$emit('startWorkflow', {
        context: this,
        item: this.editedItem,
      })
    },
    refresh() {
      this.$emit('refresh', {
        context: this,
      })
    },
    hasAdvanceRadio (item) {
      let type = ''
      if (item.is_petty_cash === 1) {
        type = 'caja_chica'
      } else if (parseFloat(item.advance) > 0) {
        type = 'anticipo'
      } else if (item.is_petty_cash === 0 && parseFloat(item.advance) <= 0) {
        type = 'reembolso'
      }
      return type
    },
    changeRequestValidator () {
      let filtered = this.filterValidators.find(
        (x) => x.id === this.editedItem.validator_id
      )
      if (filtered !== undefined) {
        let validator = {}
        if (this.editedIndex > -1) {
          if (this.editedItem.validators.length > 0) {
            validator.id = this.editedItem.validators[0].id
          }
        }
        validator.validators_id = filtered.id
        this.editedItem.validator_id = filtered.id
        this.editedItem.validators = []
        this.editedItem.validators.push(validator)
      }
    },
    extensionNumberGenerator (item, extensions) {
      let number = 0
      if (item && item.id) {
        const filterValidationId = extensions.filter(e => e && !e.id)
        let elementPos = extensions.findIndex(obj => obj.id == item.id)
        if (filterValidationId.length === 0) {
          number = elementPos + 1
        } else {
          number = elementPos
        }
      } else {
        number = extensions.length + 1
      }
      return number
    },
    extensionHandlerValidation (editedItem) {
      let disabled = false
      const extensions = editedItem.extensions
      if (extensions.length > 0) {
        const inReview = (ext) => ext.status === 'IN_REVIEW';
        let isInReview = extensions.some(inReview)
        disabled = isInReview
      }
      return disabled
    },
    sendExpenseView() {
      this.$router.push('/expenses')
    },
    closeAddExpenseDialog() {
      this.addExpenseDialog = false
      this.refresh()
    },
  },
}
</script>

<style>
.hist-steps {
  background-color: #63b225 !important;
}

.ajuste {
  padding-top: 0.4rem !important;
}
.table {
  border-collapse: collapse;
  width: 100%;
}
.td {
  border: 1px solid black;
  text-align: center;
}

.selectedRow {
  background-color: #93d2f2 !important;
}
.styled-table {
    border-collapse: collapse;
    /* margin: 8px 0; */
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: 0.9em;
    font-family: sans-serif;
    min-width: 400px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
}
.styled-table thead tr {
    background-color: #d7e1e6;
    color: #30508b;
    text-align: center;
}
.styled-table th,
.styled-table td {
    padding: 12px 15px;
    text-align: center;
}
.styled-table tbody tr {
    border-bottom: 0px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
    background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
    border-bottom: 0px solid #009879;
}
.styled-table tbody tr.active-row {
    font-weight: bold;
    color: #131f36;
}
</style>



// WEBPACK FOOTER //
// src/components/viaticRequest.component.vue